import React from 'react';
import moment from 'moment';
import { useCaseList } from '@debbie/cortex/dist/cases';
import { c, h } from '@debbie/cortex/dist';
import { CaseStatus, Money, ResponsiblePreview } from '.';
import { useSelector } from 'react-redux';
import { CornerDownRight, ExternalLink } from './Icons';
import PropertyData from './Properties/PropertyData';
import styled from 'styled-components';
import RemoteTable from './RemoteTable';
import THEME from '../theme';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import { usePropertyTypes } from '@debbie/cortex/dist/properties';
import { Site } from '@debbie/common/dist';
import { TenantType } from '@debbie/common/dist/tenants';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
const viewsMap = {
    // Jyske Finans
    ['bb5c609f-60fd-460b-a22e-b73f66cc0bb0']: {
        caseColumns: [{ handle: 'kontraktnummer' }],
        caseVoucherColumns: [
            {
                handle: 'objekttype',
            },
            {
                handle: 'fibosstatuskode',
            },
            {
                handle: 'stelnummer',
            },
            {
                handle: 'registreringsnummer',
            },
        ],
    },
    // APCOA
    ['b193c095-d699-4edc-8eef-8f4a80350289']: {
        caseColumns: [],
        caseVoucherColumns: [
            {
                handle: 'parkinglotname',
            },
            {
                handle: 'vehicleregistrationnumber',
            },
        ],
    },
    // EuroIncasso
    ['f7a160b4-feb7-4123-ac6e-ebe863f3f56e']: {
        caseColumns: [],
        caseVoucherColumns: [
            {
                handle: 'parkinglotname',
            },
            {
                handle: 'vehicleregistrationnumber',
            },
        ],
    },
};
const CaseTable = (props) => {
    var _a;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const tenant = useSelector(selectTenant);
    const tenantId = useSelector(selectTenantId);
    const creditorId = useSelector((s) => s.selectedCreditor);
    const [renderMaxCaseVouchers, setRenderMaxCaseVouchers] = React.useState({});
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : null;
    const view = (_a = (tenantId && viewsMap[tenantId])) !== null && _a !== void 0 ? _a : null;
    return (React.createElement("div", { style: { fontSize: '0.6em' } }, ((site === Site.Client && creditorId) || site === Site.Caseworker) && (React.createElement(RemoteTable, { genKey: (p) => p.caseId, pageSize: 50, onClick: (_case) => {
            c.redirect.redirect(`/cases/${_case.id}`);
        }, sortDirectionKey: "createdAt", sortKeyKey: "createdAt", initFilters: {}, selectable: false, useFetch: (_, page, pageSize) => {
            const loadable = useCaseList(props.caseFilter || {}, page, pageSize, {
                customerId: props.customerId,
            }, site === Site.Client && creditorId ? creditorId : undefined);
            if (h.hasData(loadable)) {
                return {
                    loadingState: loadable.loadingState,
                    data: Object.assign(Object.assign({}, loadable.data), { items: loadable.data.items.map((item) => {
                            return Object.assign(Object.assign({}, item), { amount: null, caseVouchers: item.caseVouchers
                                    .filter((caseVoucher) => !caseVoucher.referenceCaseVoucherId)
                                    .map((caseVoucher) => (Object.assign(Object.assign({}, caseVoucher), { referenceCaseVouchers: item.caseVouchers.filter((_caseVoucher) => _caseVoucher.referenceCaseVoucherId ===
                                        caseVoucher.caseVoucherId) })))
                                    .sort((a, b) => new Date(a.date).getTime() -
                                    new Date(b.date).getTime()) });
                        }) }),
                };
            }
            return loadable;
        }, values: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ id: {
                label: lang.cases.case,
                map: (id) => (React.createElement("div", { style: {
                        minWidth: '55px',
                    } },
                    id,
                    " ",
                    React.createElement(ExternalLink, null))),
                sortable: false,
            }, status: {
                label: lang.cases.status,
                map: (_, _case) => (React.createElement(CaseStatus, { status: _case.status, endReasonId: _case.endReasonId, statusTime: _case.statusTime })),
                sortable: false,
            } }, (site === Site.Caseworker &&
            (tenant === null || tenant === void 0 ? void 0 : tenant.type) !== TenantType.AccountsReceivable
            ? {
                creditorName: {
                    label: lang.cases.creditor,
                    map: (creditorName, e) => (React.createElement("div", { title: creditorName !== null && creditorName !== void 0 ? creditorName : undefined, style: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '90px',
                        } }, creditorName)),
                    sortable: false,
                },
            }
            : {})), ((tenant === null || tenant === void 0 ? void 0 : tenant.type) === TenantType.AccountsReceivable
            ? {
                referenceId: {
                    label: lang.cases.customerReferenceId,
                    map: (referenceId) => (React.createElement("div", { title: referenceId !== null && referenceId !== void 0 ? referenceId : undefined, style: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '90px',
                        } }, referenceId)),
                    sortable: false,
                },
            }
            : {})), { debtorNames: {
                label: lang.cases.debtorName,
                map: (debtorNames) => (React.createElement("div", { title: debtorNames !== null && debtorNames !== void 0 ? debtorNames : undefined, style: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '130px',
                    } }, debtorNames)),
                sortable: false,
            }, createdAt: {
                label: lang.cases.createdAt,
                map: (createdAt) => moment(createdAt).format(THEME.DATE_FORMAT_SHORT),
                sortable: false,
            }, groupLabel: {
                label: lang.cases.caseGroup,
                map: (groupLabel) => React.createElement(React.Fragment, null, groupLabel),
                sortable: false,
            } }), (site === Site.Caseworker
            ? {
                workflowTitle: {
                    label: lang.cases.workflow,
                    map: (workflowTitle, _case) => (React.createElement("div", { title: `${workflowTitle}${_case.currentWorkflowUpdateLabel
                            ? ` - ${_case.currentWorkflowUpdateLabel}`
                            : ''}` },
                        React.createElement("b", null, workflowTitle),
                        ' ',
                        _case.currentWorkflowUpdateLabel ? (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            _case.currentWorkflowUpdateLabel)) : (''))),
                    sortable: false,
                },
            }
            : {})), (view
            ? view.caseColumns.reduce((acc, column) => {
                const propertyType = propertyTypes === null || propertyTypes === void 0 ? void 0 : propertyTypes.find((propertyType) => propertyType.handle === column.handle);
                if (propertyType) {
                    acc[`caseProperties_${column.handle}`] = {
                        label: propertyType.label,
                        map: (_, _case) => {
                            const property = _case.properties.find((property) => property.handle === column.handle);
                            return React.createElement(PropertyData, { property: property });
                        },
                        sortable: false,
                    };
                }
                return acc;
            }, {})
            : {})), { caseId: {
                label: lang.cases.caseVoucher,
                map: (_, _case) => (React.createElement(RenderCaseVouchers, { expand: renderMaxCaseVouchers[_case.caseId], toggleExpand: () => setRenderMaxCaseVouchers(Object.assign(Object.assign({}, renderMaxCaseVouchers), { [_case.caseId]: !renderMaxCaseVouchers[_case.caseId] })), caseVouchers: _case.caseVouchers, renderCaseVoucher: (caseVoucher) => (React.createElement(React.Fragment, null,
                        // @ts-ignore
                        lang.economyVoucherTypeLabels[caseVoucher.voucherTypeId] || caseVoucher.label,
                        ' ',
                        caseVoucher.referenceId)), renderReferenceCaseVoucher: (refCaseVoucher) => (React.createElement(React.Fragment, null,
                        React.createElement(CornerDownRight, null),
                        ' ',
                        // @ts-ignore
                        lang.economyVoucherTypeLabels[refCaseVoucher.voucherTypeId] || refCaseVoucher.label,
                        ' ',
                        refCaseVoucher.referenceId)) })),
                sortable: false,
            }, amount: {
                label: lang.cases.amount,
                map: (_, _case) => (React.createElement(RenderCaseVouchers, { expand: renderMaxCaseVouchers[_case.caseId], toggleExpand: () => setRenderMaxCaseVouchers(Object.assign(Object.assign({}, renderMaxCaseVouchers), { [_case.caseId]: !renderMaxCaseVouchers[_case.caseId] })), caseVouchers: _case.caseVouchers, renderCaseVoucher: (caseVoucher) => (React.createElement("div", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: caseVoucher.amount }))), renderReferenceCaseVoucher: (refCaseVoucher) => (React.createElement("div", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: refCaseVoucher.amount }))), sum: () => (React.createElement("div", { style: { textAlign: 'right', fontWeight: 'bold' } },
                        React.createElement(Money, { color: true, amount: _case.caseVouchers.reduce((acc, caseVoucher) => {
                                const refAmount = caseVoucher.referenceCaseVouchers.reduce((azz, refCaseVoucher) => azz + refCaseVoucher.amount, 0);
                                return refAmount + acc + caseVoucher.amount;
                            }, 0) }))) })),
                sortable: false,
            } }), (view
            ? view.caseVoucherColumns.reduce((acc, column) => {
                const propertyType = propertyTypes === null || propertyTypes === void 0 ? void 0 : propertyTypes.find((propertyType) => propertyType.handle === column.handle);
                if (propertyType) {
                    acc[`caseVoucherProperties_${column.handle}`] = {
                        label: propertyType.label,
                        map: (_, _case) => (React.createElement(RenderCaseVouchers, { expand: renderMaxCaseVouchers[_case.caseId], toggleExpand: () => setRenderMaxCaseVouchers(Object.assign(Object.assign({}, renderMaxCaseVouchers), { [_case.caseId]: !renderMaxCaseVouchers[_case.caseId] })), caseVouchers: _case.caseVouchers, renderCaseVoucher: (caseVoucher) => {
                                var _a;
                                const property = (_a = caseVoucher.properties) === null || _a === void 0 ? void 0 : _a.find((property) => property.handle === column.handle);
                                return React.createElement(PropertyData, { property: property });
                            }, renderReferenceCaseVoucher: (caseVoucher) => {
                                var _a;
                                const property = (_a = caseVoucher.properties) === null || _a === void 0 ? void 0 : _a.find((property) => property.handle === column.handle);
                                return React.createElement(PropertyData, { property: property });
                            } })),
                        sortable: false,
                    };
                }
                return acc;
            }, {})
            : {})), (site === Site.Caseworker
            ? {
                responsibleReferenceId: {
                    label: lang.cases.responsible,
                    map: (responsibleReferenceId, _case) => responsibleReferenceId && _case.responsibleType ? (React.createElement(ResponsiblePreview, { responsibleReferenceId: responsibleReferenceId, responsibleType: _case.responsibleType })) : (React.createElement(React.Fragment, null)),
                    sortable: false,
                },
            }
            : {})) }))));
};
export default CaseTable;
const CaseVoucherRow = styled.div `
  height: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 90px;
`;
const ReferenceCaseVoucherRowStyled = styled.div `
  height: 15px;
  font-size: 0.8em;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 90px;
`;
const ReferenceCaseVoucherRow = (props) => {
    return (React.createElement(ReferenceCaseVoucherRowStyled, { style: props.style }, props.children));
};
const RenderCaseVouchers = (props) => {
    const lang = useSelector((s) => s.lang);
    const caseVouchers = props.expand
        ? props.caseVouchers
        : props.caseVouchers.slice(0, 3);
    return (React.createElement("div", null,
        caseVouchers.map((caseVoucher) => {
            return (React.createElement(React.Fragment, null,
                React.createElement(CaseVoucherRow, null, props.renderCaseVoucher(caseVoucher)),
                caseVoucher.referenceCaseVouchers.map((refCaseVoucher) => (React.createElement(ReferenceCaseVoucherRow, null, props.renderReferenceCaseVoucher(refCaseVoucher))))));
        }),
        caseVouchers.length < props.caseVouchers.length && (React.createElement("p", { onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                props.toggleExpand();
            }, style: {
                cursor: 'pointer',
                color: THEME.COLOR_ACCENT,
                textAlign: 'right',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '90px',
                fontWeight: 'bold',
            } }, props.sum
            ? `${lang.cases.showAll} (${props.caseVouchers.length - caseVouchers.length})`
            : '')),
        React.createElement(CaseVoucherRow, null, props.sum && props.sum())));
};
//# sourceMappingURL=CaseTable.js.map